@if (IsLoaded) {
  <div>
    <app-datalistview [Columns]="Columns" [ShowMap]="false" [ApiUrl]="ApiUrl" [AllowEdit]="false"
      [AllowCustomAction]="true" [CustomAction]="Selected" [Filters]="Filters">
    </app-datalistview>
  </div>
}